import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

/** Club side of official BW tournament sanctioning (#2691). */
export type TournamentSanction = Schema["TournamentSanctionResponse"];
export type TournamentSanctionState = Schema["TournamentSanctionStateResponse"];
export type TournamentSanctionStatus = TournamentSanction["status"];

function sanctionPath(tournamentId: string, suffix = ""): string {
  return `/tournaments/${encodeURIComponent(tournamentId)}/sanction${suffix}`;
}

export function getTournamentSanction(
  tournamentId: string,
): Promise<TournamentSanctionState> {
  return httpClient.get<TournamentSanctionState>(sanctionPath(tournamentId));
}

export function requestTournamentSanction(
  tournamentId: string,
  body: Schema["TournamentSanctionSubmit"],
): Promise<TournamentSanction> {
  return httpClient.post<TournamentSanction>(sanctionPath(tournamentId), body);
}

export function withdrawTournamentSanction(
  tournamentId: string,
  body: Schema["TournamentSanctionWithdraw"],
): Promise<TournamentSanction> {
  return httpClient.post<TournamentSanction>(
    sanctionPath(tournamentId, "/withdraw"),
    body,
  );
}

export function submitTournamentSanctionResults(
  tournamentId: string,
  body: Schema["TournamentSanctionResultsSubmit"],
): Promise<TournamentSanction> {
  return httpClient.post<TournamentSanction>(
    sanctionPath(tournamentId, "/results"),
    body,
  );
}
